import { mkPath, mkUrl, mkUrlNav } from './_';
export const districtUrls = {
    home: mkUrl(mkPath()),
    properties: mkUrlNav(mkPath('properties'), [], {
        nav: { label: 'Properties', icon: 'bi-building' },
    }),
    announcements: mkUrlNav(mkPath('announcements'), [], {
        nav: { label: 'Announcements', icon: 'bi-megaphone' },
    }),
    announcementsDetail: mkUrl(mkPath('announcements', 'detail', '$id')),
    discussions: mkUrlNav(mkPath('discussions'), [], {
        nav: { label: 'Discussions', icon: 'bi-chat-dots' },
    }),
    discussionsNew: mkUrl(mkPath('discussions', 'new')),
    discussionsDetail: mkUrl(mkPath('discussions', '$id')),
    faqs: mkUrl(mkPath('faqs')),
    mission: mkUrl(mkPath('mission')),
    resources: mkUrlNav(mkPath('resources'), [], {
        nav: { label: 'Resources', icon: 'bi-file-earmark-text' },
    }),
    events: mkUrlNav(mkPath('events'), [], {
        nav: { label: 'Events', icon: 'bi-calendar-event' },
    }),
    eventsDetail: mkUrl(mkPath('events', 'detail', '$id')),
    tours: mkUrlNav(mkPath('tours'), [], {
        nav: { label: 'Tours', icon: 'bi-signpost-2' },
    }),
    toursDetail: mkUrl(mkPath('tours', '$id')),
    toursMap: mkUrl(mkPath('tours', '$id', 'map')),
    toursHome: mkUrl(mkPath('tours', '$id', 'homes', '$stopId')),
    toursHomePhotos: mkUrl(mkPath('tours', '$id', 'homes', '$stopId', 'photos')),
    about: mkUrlNav(mkPath('about'), [], {
        nav: { label: 'About', icon: 'bi-info-circle' },
    }),
    policy: mkUrl(mkPath('policy', '$kind')),
};
